<template>
  <v-expansion-panels v-model="nodesPanel" class="node-expansion-panel" flat >

    <v-expansion-panel v-show="getFolderSearchResults.length > 0" style="" data-cy="nodeSideMenu----">
      <v-expansion-panel-title
        :color="nodesPanel == 0 ? 'primary' : ''"
        @contextmenu.prevent="showExpansionMenu"
        expand-icon="mdi-menu-down"
        ripple
      >
        <div class="d-flex flex-fill justify-space-between">
          <div>
            <v-icon size="small" class="mr-1">mdi-magnify</v-icon>
            {{$t('menus.nodeList.searchResults')}}
          </div>
          <div>
            <v-chip size="x-small">{{getFolderSearchResults.length}}</v-chip>
          </div>
        </div>

      </v-expansion-panel-title>
      <v-expansion-panel-text>
        <div v-for="node in getFolderSearchResults" :key="node.id" class="py-2">
          <router-link v-if="node.parent" :to="'/node/' + node.parent.id" style="color: unset;">
            <v-icon size="small">
              {{getNodeIcon(node.parent)}}
            </v-icon>
            {{node.parent.name}}
          </router-link>
          <span v-if="node.parent"> / </span>
          <router-link :to="'/node/'+node.id" style="color: unset;">
            <v-icon size="small">
              {{getNodeIcon(node)}}
            </v-icon>
            {{node.name}}
          </router-link>
        </div>
      </v-expansion-panel-text>
    </v-expansion-panel>

    <v-expansion-panel style="" data-cy="nodeSideMenu-allFolders">
      <v-expansion-panel-title
        :color="nodesPanel == 1 ? 'primary' : ''"
        @contextmenu.prevent="showExpansionMenu"
        expand-icon="mdi-menu-down"
        ripple
      >

        <div class="d-flex flex-fill justify-space-between">
          <div>
            <v-icon size="small" class="mr-1">mdi-folder</v-icon>
            {{ $t('menus.nodeList.allFolders') }}
          </div>
          <div>
            <v-chip size="x-small">{{ getSortedChildren.length }}</v-chip>
          </div>
        </div>

      </v-expansion-panel-title>
      <v-expansion-panel-text>
        <div
          v-if="isLoadingAccessPoints || (nodeTreeIds.length > 0 && accessPoints.length > 0 && openedNodeIds.length === 0)"
          class="d-flex justify-center py-2">
            <v-progress-circular
              :size="40"
              :width="4"
              indeterminate
              color="primary"
              :aria-label="$t('common.loading')"
            />
        </div>

        <div v-if="!isLoadingAccessPoints && nodeTreeIds.length === 0 && accessPoints.length === 0" style="padding: 16px 0">
          {{$t('menus.nodeList.noAccess')}}
        </div>

        <div v-if="openedNodeIds.length !== 0">
          <NodeTreeItem
            v-for="node in getSortedChildren"
            :key="node.id"
            :node="node"
            :sortFunction="getSortFunction"
            :openedIds="openedNodeIds"
            @showContextMenu="showContextMenuEvent"
            @droppedMovableItems="droppedMovableItems($event)"
          />
        </div>
      </v-expansion-panel-text>
    </v-expansion-panel>

    <v-expansion-panel v-show="getClientNodes.length > 0" data-cy="nodeSideMenu-Clients">
      <v-expansion-panel-title
        :color="nodesPanel == 2 ? 'primary' : ''"
        @contextmenu.prevent="showExpansionMenu"
        expand-icon="mdi-menu-down"
        ripple
      >

        <div class="d-flex flex-fill justify-space-between">
          <div>
            <v-icon size="small" class="mr-1">tw tw-office-building</v-icon>
            {{ $t('menus.nodeList.clients') }}
          </div>
          <div>
            <v-chip size="x-small">{{ getClientNodes.length }}</v-chip>
          </div>
        </div>

      </v-expansion-panel-title>
      <v-expansion-panel-text>

        <NodeTreeItem
          v-for="node in getClientNodes"
          :key="node.id"
          :node="node"
          :sortFunction="getSortFunction"
          @showContextMenu="showContextMenuEvent"
          @droppedMovableItems="droppedMovableItems($event)"
        >
        </NodeTreeItem>

      </v-expansion-panel-text>
    </v-expansion-panel>

    <v-expansion-panel v-show="getProjectNodes.length > 0" data-cy="nodeSideMenu-Projects">
      <v-expansion-panel-title
        :color="nodesPanel == 3 ? 'primary' : ''"
        @contextmenu.prevent="showExpansionMenu"
        expand-icon="mdi-menu-down"
        ripple
      >

        <div class="d-flex flex-fill justify-space-between">
          <div>
            <v-icon size="small" class="mr-1">mdi-briefcase-clock</v-icon>
            {{ $t('menus.nodeList.projects') }}
          </div>
          <div>
            <v-chip size="x-small">{{ getProjectNodes.length }}</v-chip>
          </div>
        </div>

      </v-expansion-panel-title>
      <v-expansion-panel-text>

        <NodeTreeItem
          v-for="node in getProjectNodes"
          :key="node.id"
          :node="node"
          :sortFunction="getSortFunction"
          @showContextMenu="showContextMenuEvent"
          @droppedMovableItems="droppedMovableItems($event)"
        >
        </NodeTreeItem>

      </v-expansion-panel-text>
    </v-expansion-panel>

    <v-expansion-panel v-show="getArchivedNodes.length > 0" data-cy="nodeSideMenu-Projects">
      <v-expansion-panel-title
        :color="nodesPanel == 4 ? 'primary' : ''"
        @contextmenu.prevent="showExpansionMenu"
        expand-icon="mdi-menu-down"
        ripple
      >

        <div class="d-flex flex-fill justify-space-between">
          <div>
            <v-icon size="small" class="mr-1">mdi-package-down</v-icon>
            {{ $t('menus.nodeList.archived') }}
          </div>
          <div>
            <v-chip size="x-small">{{ getArchivedNodes.length }}</v-chip>
          </div>
        </div>

      </v-expansion-panel-title>
      <v-expansion-panel-text>

        <NodeTreeItem
          v-for="node in getArchivedNodes"
          :key="node.id"
          :node="node"
          :sortFunction="getSortFunction"
          @showContextMenu="showContextMenuEvent"
        >
        </NodeTreeItem>

      </v-expansion-panel-text>
    </v-expansion-panel>

    <v-expansion-panel>
      <v-expansion-panel-title
        :color="nodesPanel == 5 ? 'primary' : ''"
        expand-icon="mdi-menu-down"
        ripple
        @contextmenu.prevent="showRecycleBinContextMenu"
        @click="$router.currentRoute.path !== `/recycle-bin/${getRootNodeId}` && $router.push(`/recycle-bin/${getRootNodeId}`)"
      >
        <div class="d-flex flex-fill justify-space-between">
          <div>
            <v-icon size="small" class="mr-1">mdi-recycle</v-icon>
            {{ $t('menus.nodeList.recycleBin') }}
          </div>
          <div><v-chip size="x-small">{{ getRecycleBinPodsCount }}</v-chip></div>
        </div>

        <template v-slot:actions>
          <v-icon style="visibility: hidden;">
            mdi-delete-circle
          </v-icon>
        </template>
      </v-expansion-panel-title>

      <!-- <v-expansion-panel-content>
        <NodeRecycleBinTreeItem
          v-for="node in getRecycleBinRootNodes"
          :key="node.id"
          :node="node"
          @contextMenu="showRecycleBinContextMenu"
        />
      </v-expansion-panel-content> -->
    </v-expansion-panel>

    <ExpansionpanelContextMenu
      v-model="expansionMenu"
      :positionX="expansionMenuX"
      :positionY="expansionMenuY"
      :sortString="sortString"
      @setSort="setNodeSort"
    />

    <NodeContextMenu
      v-if="contextMenuNode && contextMenuNode.archived === archiveStatus.NOTARCHIVED"
      v-model="showContextMenu"
      :positionX="contextMenuX"
      :positionY="contextMenuY"
      :node="contextMenuNode"
      :key="contextMenuX * contextMenuY"
    />

    <ArchivedNodeContextMenu
      v-if="contextMenuNode && contextMenuNode.archived === archiveStatus.ARCHIVED"
      v-model="showContextMenu"
      :positionX="contextMenuX"
      :positionY="contextMenuY"
      :node="contextMenuNode"
      :key="contextMenuX * contextMenuY"
    />

    <RecycleBinContextMenu
      v-model="recycleBinContextMenu"
      :items-count="getRecycleBinPodsCount"
      :position-y="recycleBinContextMenuY"
      :position-x="recycleBinContextMenuX"
      :retention-period="getRecycleBinRetentionPeriod"
      @contextMenuItemClicked="recycleBinContextMenu = false"
    />

    <MoveDroppedDialog
      v-if="getCurrentNode"
      v-model="showMoveDroppedDialog"
      :targetNodeId="dropTargetNodeId"
      :podIds="dropPodIds"
      :nodeIds="dropNodeIds"
      @update:modelValue="showMoveDroppedDialog = $event"
    />
  </v-expansion-panels>
</template>

<script>
import { useAuthStore } from '@/stores/AuthStore.js'
import { useNodeStore } from '@/stores/NodeStore.js'
import { useCommonStore } from '@/stores/CommonStore.js'
import { useSearchStore } from '@/stores/SearchStore.js'
import { useTenantStore } from '@/stores/TenantStore.js'
import { useRecycleBinStore } from '@/stores/RecycleBinStore.js'
import NodeTreeItem from './NodeTreeItem.vue'
import NodeContextMenu from '../../../../routes/nodes2/components/contextMenus/NodeContextMenu.vue'
import ArchivedNodeContextMenu from '../../../../routes/nodes2/components/contextMenus/ArchivedNodeContextMenu.vue'
import ExpansionpanelContextMenu from './components/ExpansionpanelContextMenu.vue'
import RecycleBinContextMenu from '@/layouts2/mainLayout/components/nodeSidemenu/components/RecycleBinContextMenu.vue';
import MoveDroppedDialog from '../../../../routes/nodes2/components/dialogs/MoveDroppedDialog.vue';


export default {
  name: "NodeExpansionPanel",
  components: {
    RecycleBinContextMenu,
    // NodeRecycleBinTreeItem,
    NodeTreeItem,
    NodeContextMenu,
    ArchivedNodeContextMenu,
    ExpansionpanelContextMenu,
    MoveDroppedDialog,
  },
  props: {
    // searchText: String,
  },
  data() {
    return {
      nodesPanel: this.$route.name === 'recycle-bin' ? 5 : 1,
      recycleBinTransitionPanel: this.$route.name === 'recycle-bin' ? 1 : null,
      recycleBinTransitionRoute: null,

      // The context menu for custom tree
      showContextMenu: false,
      contextMenuNode: null,
      contextMenuX: 0,
      contextMenuY: 0,

      sortString: 'nameAsc',
      expansionMenu: false,
      expansionMenuX: 0,
      expansionMenuY: 0,

      nodeTreeIds: [],
      openedNodeIds: [],

      recycleBinContextMenu: false,
      recycleBinContextMenuX: 0,
      recycleBinContextMenuY: 0,

      showMoveDroppedDialog: false,
      dropTargetNodeId: null,
      dropPodIds: [],
      dropNodeIds: [],
    };
  },
  watch: {
    accessPoints(newValue, oldValue) {
      // Check if the ID's of the old value and new value differ
      let newAccessPointIds = (newValue || []).map(x => x.id);
      let oldAccessPointIDs = (oldValue || []).map(x => x.id);

      for (let i = 0; i < newAccessPointIds.length; i++) {
        if (oldAccessPointIDs.indexOf(newAccessPointIds[i]) < 0) {
          this.refreshAll();
          return;
        }
      }
    },
    getRootNodeId(oldID, newID) {
      if (oldID !== newID) {

        this.refreshAll();
      }
    },
    getCurrentNode(newNode) {
      const newRouteId = String(this.$route.params.id);

      if (newNode &&
          newNode.id == newRouteId &&
          this.nodeTreeIds.indexOf(newRouteId) < 0)
      {
        this.updateNodeTreeRecursive(newNode.id);
      }
    },
    getFolderSearchResults(newResults) {
      if (newResults && newResults.length !== 0) {
        this.nodesPanel = 0;
      }
    },
    nodesPanel(newValue, oldValue) {
      if (oldValue && newValue === 5) {
        this.recycleBinTransitionPanel = oldValue;
      }
    },
    $route(to, from) {
      if (to.name === 'recycle-bin') {
        this.recycleBinTransitionRoute = from;
      } else if (from.name === 'recycle-bin' && (!this.recycleBinTransitionRoute || to.path === this.recycleBinTransitionRoute?.path)) {
        this.nodesPanel = this.recycleBinTransitionPanel;
        this.recycleBinTransitionRoute = null;
        this.recycleBinTransitionPanel = null;
      }
    }
  },
  methods: {
    async refreshAll() {
      if (!this.getRootNodeId) {
        return;
      }

      const promises = [
        this.getSubnodes(this.getRootNodeId, this.NODETYPES.CLIENT),
        this.getSubnodes(this.getRootNodeId, this.NODETYPES.PROJECT),
        this.getSubnodes(this.getRootNodeId, 'archived'),
        this.refreshRecycleBin(this.getRootNodeId),
      ];

      await Promise.all(promises);
    },
    async refreshRecycleBin(nodeId) {
      const recycleBinStore = useRecycleBinStore();

      try {
        // The tenant settings contains the recycle bin retention period.
        // The tenant settings are obtained in the MainLayout.

        const payload = {
          rootNodeId: this.getRootNodeId,
          silent: false,
        };

        return recycleBinStore.refreshNodesList(payload);
      } catch (error) {
        console.error(`Failed to refresh recycle bin info for node ${nodeId}`, error);
      }
    },
    getSubnodes(nodeId, type) {
      const payload = {
        nodeid: nodeId,
        type: type,
      };

      try {
        const nodeStore = useNodeStore();
        return nodeStore.getSubnodes(payload);
      } catch (error) {
        console.error(`Error getting the subnodes of node Id ${nodeId}!`, error);
      }
    },
    showContextMenuEvent(event) {
      this.expansionMenu = false;

      this.showContextMenu = false;
      this.contextMenuNode = event.contextMenuNode;
      this.contextMenuX = event.contextMenuX;
      this.contextMenuY = event.contextMenuY;
      this.$nextTick(() => {
        this.showContextMenu = true;
      });
    },
    showExpansionMenu(event) {
      this.showContextMenu = false;

      this.expansionMenu = false;
      this.expansionMenuX = event.clientX;
      this.expansionMenuY = event.clientY;

      this.$nextTick(() => {
        this.expansionMenu = true;
      });
    },
    showRecycleBinContextMenu(event) {
      this.recycleBinContextMenu = false;
      this.recycleBinContextMenuX = event.clientX;
      this.recycleBinContextMenuY = event.clientY;
      this.$nextTick(() => {
        this.recycleBinContextMenu = true;
      });
    },
    setNodeSort(sortString) {
      this.sortString = sortString;
    },
    async updateNodeTreeRecursive(nodeId) {
      // UpdateNodeTree Recursive

      this.nodeTreeIds = [];
      await this.updateNodePath(nodeId)

      // trigger the update on the nodes
      this.openedNodeIds = this.nodeTreeIds;
    },
    async updateNodePath(nodeId) {
      this.nodeTreeIds.push(nodeId);

      const nodeStore = useNodeStore();
      let nodeData = await nodeStore.getNodeInfo(nodeId);

      if (nodeData.parentid) {
        await this.updateNodePath(nodeData.parentid);
      }
    },
    droppedMovableItems($event) {
      this.dropTargetNodeId = $event.targetNodeId;
      this.dropPodIds = $event.podIds;
      this.dropNodeIds = $event.nodeIds;

      this.showMoveDroppedDialog = true;
    },
  },
  computed: {
    NODETYPES: function() {
      const commonStore = useCommonStore();
      return commonStore.nodeTypes;
    },
    archiveStatus() {
      const commonStore = useCommonStore();
      return commonStore.archiveStatus;
    },
    accessPoints() {
      const nodeStore = useNodeStore();
      return nodeStore.getAccessPoints;
    },
    getCurrentNode() {
      const nodeStore = useNodeStore();
      return nodeStore.getCurrentNode;
    },
    getNodeById() {
      return (nodeId) => {
        const nodeStore = useNodeStore();
        return nodeStore.getNodeById(nodeId);
      }
    },
    getChildrenById() {
      return (parentId) => {
        const nodeStore = useNodeStore();
        return nodeStore.getChildrenById(parentId);
      }
    },

    getRootNodeId() {
      const authStore = useAuthStore();
      return authStore.rootNodeId;
    },
    getAccesspointChildren() {
      if (this.getRootNodeId) {
        return this.getChildrenById(this.getRootNodeId);
      }

      return [];
    },
    getFilteredChildren() {
      // if (this.searchText) {
      //   const searchLowerCase = this.searchText.toLowerCase();

      //   return this.getAccesspointChildren.filter(
      //     node => node.name.toLowerCase().includes(searchLowerCase)
      //   );
      // }

      return this.getAccesspointChildren;
    },
    getSortedChildren() {
      // First create shallow copy of the array and the sort
      return this.getFilteredChildren.slice().sort(this.getSortFunction);
    },


    getClientNodes() {
      return this.getNodesByType(this.NODETYPES.CLIENT).slice().sort(this.getSortFunction);
    },
    getProjectNodes() {
      return this.getNodesByType(this.NODETYPES.PROJECT).slice().sort(this.getSortFunction);
    },
    getNodesByType() {
      return (typeId) => {
        const nodeStore = useNodeStore();
        return nodeStore.getNodesByType(typeId);
      }
    },
    getArchivedNodes() {
      const nodeStore = useNodeStore();
      return nodeStore.getArchivedNodes();
    },

    getSortFunction() {
      if (this.sortString === "nameAsc") {
        return (a, b) => {
          const nameA = a.name.toLowerCase();
          const nameB = b.name.toLowerCase();

          if (nameA > nameB)  return 1;
          if (nameA == nameB) return 0;
          return -1;
        }
      }

      if (this.sortString === "nameDesc") {
        return (a, b) => {
          const nameA = a.name.toLowerCase();
          const nameB = b.name.toLowerCase();

          if (nameA < nameB)  return 1;
          if (nameA == nameB) return 0;
          return -1;
        }
      }

      if (this.sortString === "dateAsc") {
        return (a, b) => {
          const createdAtA = new Date(a.createdat);
          const createdAtB = new Date(b.createdat);

          if (createdAtA > createdAtB) return 1;
          if (createdAtA == createdAtB) return 0;
          return -1;
        }
      }

      if (this.sortString === "dateDesc") {
        return (a, b) => {
          const createdAtA = new Date(a.createdat);
          const createdAtB = new Date(b.createdat);

          if (createdAtA < createdAtB) return 1;
          if (createdAtA == createdAtB) return 0;
          return -1;
        }
      }

      return function() {return true};
    },

    getFolderSearchResults() {
      const searchStore = useSearchStore();
      return searchStore.getFolderSearchResults;
    },
    getNodeIcon() {
      return (node) => {
        if (node.archived === 1 || node.archived === 2) {
          return 'mdi-package-down';
        }

        let iconName;

        switch (node.type) {
          // case 1: iconName = 'mdi-folder'; break;
          case 2: iconName = 'mdi-briefcase-clock'; break;
          case 3: iconName = 'tw tw-office-building'; break;
          case 4: iconName = 'mdi-home-assistant'; break;
          default: iconName = 'mdi-folder'; break;
        }

        return iconName;
      }
    },
    isLoadingAccessPoints() {
      const nodeStore = useNodeStore();
      return nodeStore.getIsLoadingAccessPoints;
    },
    getRecycleBinPodsCount() {
      const recycleBinStore = useRecycleBinStore();
      return recycleBinStore.getAllPods.length;
    },
    getRecycleBinRootNodes() {
      const recycleBinStore = useRecycleBinStore();
      const accessPointNode = recycleBinStore.getNodeById(this.getRootNodeId);

      if (accessPointNode) {
        return recycleBinStore.getChildNodes(accessPointNode.id);
      }

      return recycleBinStore.getChildNodes(null);
    },
    getRecycleBinRetentionPeriod() {
      const tenantStore = useTenantStore();
      return tenantStore.getTenantRetentionPeriod;
    },
  }
}
</script>

<style lang="scss">
.node-expansion-panel {
  .v-expansion-panel {
    margin: 2px 0;
    background-color: unset;
    border-radius: 0;

    color: var(--tw-icons-colors-default) !important;

    .v-expansion-panel-title {
      border-radius: 4px;
    }

    .v-expansion-panel-text {
      .v-expansion-panel-text__wrapper {
        padding: 0 8px 8px !important;
      }
    }
  }

  .v-item--active {
    .v-expansion-panel-title {
      color: #131313;

      .v-icon {
        color: #131313;
        border-radius: 4px;
      }
    }
  }
}
</style>
